<template>
    <v-container fluid class="my-0 px-0  py-0">
        <q-content-submenu ref="contentMenu" :nav-menu-id="navMenuId"></q-content-submenu>
        <div :class="stickybuffer ? 'q-sticky-buffer' : ''">
            <v-container fluid class="px-5 transparent site-width">
                <slot></slot>
            </v-container>
        </div>
    </v-container>
</template>
<script>
import QContentSubmenu from '@/components/navigation/Submenus/QContentSubmenu.vue';
export default {
    props: ['navMenuId'],
    data: () => ({
        stickybuffer: false
    }),
    mounted: function() {
        setTimeout(this.maybeSetStickyBuffer, 100)
    },
    components: {
        QContentSubmenu,
    },
    methods: {
        maybeSetStickyBuffer: function() {
            if (typeof this.navMenuId != 'undefined' && this.navMenuId > 0) {
                this.stickybuffer = true
            }
            if (typeof this.$refs.contentMenu != 'undefined' && this.$refs.contentMenu.buttons.length > 0) {
                this.stickybuffer = true
            }
        }
    },
    computed: {},
    watch: {
        '$refs.contentMenu.buttons': function() {
            this.$nextTick(this.maybeSetStickyBuffer)
        }
    }
}
</script>